import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "chat-modal" }
const _hoisted_2 = { class: "notification-item" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "chat-title" }
const _hoisted_5 = { class: "chat-content" }
const _hoisted_6 = { class: "message-item-right" }
const _hoisted_7 = { class: "unread-count" }
const _hoisted_8 = { class: "chat-time" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "notification-item" }
const _hoisted_11 = ["src"]

import { getTimeDifference } from '@/utils/timeUtils';
import info from '@/assets/icon/notification/info.svg';
import { chatRoomList } from '@/static/data/chatData';

export default /*@__PURE__*/_defineComponent({
  __name: 'ChatModal',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", null, [
      _createElementVNode("p", null, "Chat List")
    ], -1)),
    _cache[2] || (_cache[2] = _createElementVNode("hr", null, null, -1)),
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(chatRoomList), (chat) => {
        return (_openBlock(), _createElementBlock("li", {
          key: chat.id
        }, [
          _createVNode(_component_router_link, {
            to: '/workspace/' + chat.workspaceId + '/dashboard'
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("img", {
                  src: chat.profilePic,
                  alt: "alam",
                  class: "notify-img"
                }, null, 8, _hoisted_3),
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_4, _toDisplayString(chat.chatRoomName), 1),
                  _createElementVNode("p", _hoisted_5, _toDisplayString(chat.messageContents), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(chat.unreadMessages), 1),
                _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(getTimeDifference)(chat.createdAt)), 1)
              ])
            ]),
            _: 2
          }, 1032, ["to"])
        ]))
      }), 128)),
      (_ctx.chatRoomStore.chatRoom.length === 0)
        ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("img", {
                src: _unref(info),
                alt: "alam"
              }, null, 8, _hoisted_11),
              _cache[0] || (_cache[0] = _createElementVNode("div", null, [
                _createElementVNode("p", { class: "chat-title" }, " 안읽은 메시지가 없습니다.")
              ], -1))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})